import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';

// Not Enabled
export default class ChangeMobileService extends CommonService {
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCode = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCode({
      ...rest,
      type: 20,
      ...extra_params,
    });
  };

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCodeV2({
      ...rest,
      type: 20,
      ...extra_params,
    });
  };
  /**
   * [update bind mobile number]
   * @param {string} mobile new mobile
   * @param {string} code verifyCode
   */
  public mobileChange = (params: {
    mobile: string;
    code: string;
    extra_params?: object;
  }): Promise<any> => {
    let { mobile, code, extra_params = {}, ...rest } = params;
    const data = encryptParams({ mobile, code, ...rest, ...extra_params }, [
      'mobile',
      'code',
    ]);
    return this.request({
      url: WEB_SSO.CHANGE_MOBILE,
      method: 'POST',
      data,
    });
  };
}
